export enum ActivityLogTypeModel
{
    EventInvitationSentByEmail = 0,
    CertificateSentByEmail = 1,
    LearningPathInvitationSent = 2,
    TrainerParticipationInvitationSent = 3,
    CourseManuallyCompleted = 4,
    ParticipantIddTimeManuallyChanged = 5
}
